const CONST = {
    RESET: 'JWT_DECODER/RESET',
    UPDATE_STATE: 'JWT_DECODER/UPDATE_STATE',
    UPDATE_JWT_TOKEN: 'JWT_DECODER/UPDATE_JWT_TOKEN',
    UPDATE_DECODED_DATA_SUCCESS: 'JWT_DECODER/UPDATE_DECODED_DATA_SUCCESS',
    UPDATE_DECODED_DATA_FAILED: 'JWT_DECODER/UPDATE_DECODED_DATA_FAILED',
    UPDATE_ACTIVE_TAB: 'JWT_DECODER/UPDATE_ACTIVE_TAB',
};

export default CONST;

